var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Trafficking",
    "data-name": "Icon - Trafficking",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1960",
    "data-name": "Group 1960",
    transform: "translate(0 0.155)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(0 -0.155)",
    fill: "#84a0ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "downloading_FILL0_wght400_GRAD0_opsz24",
    d: "M8.075,18a8.748,8.748,0,0,1-3.192-.959A9.083,9.083,0,0,1,.62,12.293,8.812,8.812,0,0,1,0,9,8.737,8.737,0,0,1,2.312,2.944,8.849,8.849,0,0,1,8.1,0V1.8A7.11,7.11,0,0,0,3.586,4.229,7.028,7.028,0,0,0,1.8,9a7.027,7.027,0,0,0,1.782,4.771A7.093,7.093,0,0,0,8.075,16.2Zm.9-4.466L4.444,8.977,5.729,7.692l2.346,2.346V4.511h1.8v5.526L12.2,7.714l1.286,1.308ZM9.88,18V16.2a7.205,7.205,0,0,0,1.861-.519,7.786,7.786,0,0,0,1.658-.97l1.308,1.308a9.706,9.706,0,0,1-2.278,1.342A8.944,8.944,0,0,1,9.88,18ZM13.444,3.293a8.335,8.335,0,0,0-1.68-.97A7.2,7.2,0,0,0,9.9,1.8V0a8.939,8.939,0,0,1,2.549.643,9.274,9.274,0,0,1,2.256,1.342ZM15.97,14.707l-1.263-1.286a7.113,7.113,0,0,0,.947-1.658,7.811,7.811,0,0,0,.5-1.861H18a10.627,10.627,0,0,1-.677,2.56A8.236,8.236,0,0,1,15.97,14.707ZM16.15,8.1a7.811,7.811,0,0,0-.5-1.861,7.113,7.113,0,0,0-.947-1.658L15.97,3.293a8.7,8.7,0,0,1,1.376,2.244A8.851,8.851,0,0,1,18,8.1Z",
    transform: "translate(27 27) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.3bcb696cd78edd81c69157b643849730.svg";
export { ForwardRef as ReactComponent };